import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';
import { KnBrInvoiceAccountSummaryComponent } from './kn-br-invoice-account-summary.component';
import { KnBrCustomPipesModule } from 'src/app/shared/pipe/kn-br-custom-pipes/kn-br-custom-pipes.module';
import { CwtInvoiceHeaderComponent } from '../cwt-invoice-header/cwt-invoice-header.component';

@NgModule({
    imports: [
        CommonModule,
        I18nModule,
        KnBrCustomPipesModule,
        ConfigModule.withConfig({
            cmsComponents: {
                'CwtInvoiceHeaderComponent-due-balance': {
                    component: KnBrInvoiceAccountSummaryComponent,
                },
                CwtInvoiceHeaderComponent: {
                    component: CwtInvoiceHeaderComponent,
                },
            },
        } as CmsConfig),
        KnBrInvoiceAccountSummaryComponent, CwtInvoiceHeaderComponent,
    ],
})
export class KnBrInvoiceAccountSummaryModule {}
